import SubcategoryPage from '@/components/template/SubcategoryPage';

const KeramicniDodatki = () => {
  const products = [
    {
      title: "Keramična vaza Terra",
      imageSrc: "https://images.unsplash.com/photo-1586798532065-b3a32857c5c4?auto=format&fit=crop&q=80",
      url: "/dodatki/keramicni/terra"
    },
    {
      title: "Keramični podstavki Argilla",
      imageSrc: "https://images.unsplash.com/photo-1609108479377-32762a28613b?auto=format&fit=crop&q=80",
      url: "/dodatki/keramicni/argilla"
    },
    {
      title: "Keramična posoda Cotto",
      imageSrc: "https://images.unsplash.com/photo-1578749556568-bc2c40e68b61?auto=format&fit=crop&q=80",
      url: "/dodatki/keramicni/cotto"
    },
    {
      title: "Keramični okrasni krožniki Forma",
      imageSrc: "https://images.unsplash.com/photo-1610701596007-11502861dcfa?auto=format&fit=crop&q=80",
      url: "/dodatki/keramicni/forma"
    }
  ];

  return (
    <SubcategoryPage
      title="Keramični dodatki"
      description="Ročno izdelani keramični dodatki, ki s svojo teksturo in unikatnostjo vdihnejo dušo vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1586798532065-b3a32857c5c4?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default KeramicniDodatki;